import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function H() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'];

    return (
        <div id="RV-H" className={`RV-H RV-box ${css['RV-H']}`}>
            <div className="info-box">
                <p className="title">{t('H_title')}</p>
                <p className="desc">{t('H_desc')}</p>
            </div>
            <div className="wrapper">
                <p className="label awards">{t('H_sub1')}</p>
                <ul className="items awards">
                    <li className="item">
                        <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077755288/8_1.png" alt={t('H_sub1')} />
                    </li>
                    <li className="item">
                        <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077768591/8_2.png" alt={t('H_sub1')} />
                    </li>
                    <li className="item">
                        <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077779906/8_3.png" alt={t('H_sub1')} />
                    </li>
                    <li className="item">
                        <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077792356/8_4.png" alt={t('H_sub1')} />
                    </li>
                    <li className="item">
                        <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077804411/8_5.png" alt={t('H_sub1')} />
                    </li>
                    <li className="item">
                        <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077815044/8_6.png" alt={t('H_sub1')} />
                    </li>
                </ul>
                {!EU_SITES?.includes(locale) && (
                    <>
                        <p className="label partners">{t('H_sub2')}</p>
                        <ul className="items partners">
                            <li className="item">
                                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077936812/8_7.png" alt={t('H_sub2')} />
                            </li>
                            <li className="item">
                                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077950362/8_8.png" alt={t('H_sub2')} />
                            </li>
                            <li className="item">
                                {' '}
                                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077961847/8_9.png" alt={t('H_sub2')} />
                            </li>
                            <li className="item">
                                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077974107/8_10.png" alt={t('H_sub2')} />
                            </li>
                            <li className="item">
                                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077985527/8_11.png" alt={t('H_sub2')} />
                            </li>
                        </ul>
                    </>
                )}
            </div>
        </div>
    );
}
